import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class Scope extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Topics of Interest (include but are not limited to):</h4>
            <div className="par">
              <b>APPLICATIONS:</b>
              <ul>
                <li>LLMs in education: tutoring, assessment, and curriculum design</li>
                <li>Biomedical and scientific discovery with LLMs</li>
                <li>Legal document processing and contract analysis</li>
                <li>LLMs in software engineering (e.g., code generation, bug detection)</li>
                <li>Interactive AI agents and autonomous systems driven by LLMs</li>
                <li>Scientific Research</li>
                <li>Business and Productivity</li>
                <li>Creative Arts</li>
                <li>Journalism and Media</li>
                <li>Multimodal Integration</li>
              </ul>
              <br/>
              <b>CONTROVERSIAL OR ETHICALLY SENSITIVE APPLICATIONS:</b>
              <ul>
                <li>
                  <b>Misinformation and Manipulation:</b>
                  <ul>
                    <li>Fake news generation</li>
                    <li>Astroturfing / fake reviews</li>
                    <li>Deepfake text personas</li>
                  </ul>
                </li>
                <li>
                  <b>Surveillance and Privacy Violations:</b>
                  <ul>
                    <li>Chat log monitoring with LLMs</li>
                    <li>Re-identification risks: Extracting personal information from anonymized datasets</li>
                  </ul>
                </li>
                <li>
                  <b>Autonomy and Human Judgment:</b>
                  <ul>
                    <li>Decision automation in high-stakes areas</li>
                    <li>Weaponized persuasion: Micro-targeting individuals with persuasive arguments</li>
                  </ul>
                </li>
                <li>
                  <b>Bias, Discrimination, and Fairness:</b>
                  <ul>
                    <li>Biased legal or hiring recommendations</li>
                    <li>Discriminatory healthcare advice</li>
                    <li>Unequal language representation</li>
                  </ul>
                </li>
                <li>
                  <b>Academic and Creative Integrity:</b>
                  <ul>
                    <li>Plagiarism and ghostwriting</li>
                    <li>Undermining artistic credit</li>
                  </ul>
                </li>
                <li>
                  <b>Existential and Societal Risk:</b>
                  <ul>
                    <li>Autonomous agents: LLMs used as the "brain" for agents that can act online</li>
                    <li>Acceleration of job displacement</li>
                  </ul>
                </li>
              </ul>
              <br/>
              <b>MODEL ARCHITECTURE & TRAINING:</b>
              <ul>
                <li>Transformer architecture advancements and alternatives</li>
                <li>Efficient training techniques for LLMs (e.g., LoRA, quantization, sparsity)</li>
                <li>Scaling laws and emergent behaviors in LLMs</li>
                <li>Transfer learning and domain adaptation in large-scale models</li>
                <li>Data selection and curation for training LLMs</li>
              </ul>
              <br/>
              <b>CAPABILITIES & LIMITATIONS:</b>
              <ul>
                <li>Few-shot and zero-shot learning with LLMs</li>
                <li>Reasoning, abstraction, and multi-step thinking in LLMs</li>
                <li>Hallucination: causes, detection, and mitigation</li>
                <li>Memory and retrieval in LLMs (e.g., RAG: Retrieval-Augmented Generation)</li>
                <li>LLM performance across languages, dialects, and code-switching</li>
              </ul>
              <br/>
              <b>EVALUATION & BENCHMARKING:</b>
              <ul>
                <li>Designing robust benchmarks for LLM capabilities</li>
                <li>Evaluating factual accuracy, consistency, and reliability</li>
                <li>User-centered evaluation: utility, trust, and satisfaction</li>
                <li>Stress-testing LLMs for adversarial robustness</li>
                <li>Multimodal evaluation in models combining text, vision, and audio</li>
              </ul>
              <br/>
              <b>ETHICS, SAFETY & GOVERNANCE:</b>
              <ul>
                <li>Bias, fairness, and representation in LLM training data</li>
                <li>Controlling toxic, harmful, or misleading outputs</li>
                <li>Explainability and interpretability in LLM behavior</li>
                <li>AI policy, regulation, and global governance of foundation models</li>
                <li>Copyright, authorship, and intellectual property in LLM-generated content</li>
              </ul>
              <br/>
              <b>HUMAN-AI INTERACTION:</b>
              <ul>
                <li>Prompt engineering and interaction design for LLMs</li>
                <li>Cognitive offloading: when and how users rely on LLMs</li>
                <li>Human-in-the-loop systems using LLMs for decision support</li>
                <li>Trust calibration in human-LLM collaboration</li>
                <li>Personalization and user modeling in conversational AI</li>
              </ul>
            </div>
          </div>
          

        </div>
      </div>
    );
  }
}

export default Scope;